// @ts-check

import './parts/modal';
import './parts/file-input';
import './parts/contact-links';

import './blocks/gallery';
import './blocks/info-panels';
import './blocks/features';
import './blocks/gallery-and-content';
import './blocks/paged-form';

import { nextArrow, prevArrow } from './parts/slick-defaults';

jQuery( document ).foundation();

jQuery( function() {
  //Show uploaded file on label instead of the default file input!
  document.querySelector( 'input[type=file]' )?.addEventListener( 'change', event => {
    let fileName = event.currentTarget.value;
    if ( !fileName ) { fileName = "Choose file"; }
    else {
      const lastIndex = fileName.lastIndexOf( "\\" );
      if ( lastIndex >= 0 ) {
        fileName = fileName.substring( lastIndex + 1 ) + " chosen";
      }
    }
    document.querySelector( '.custom-file-upload' ).innerHTML = fileName;
  } );


  // Mobile menu logic
  jQuery( ".menu-item-has-children > a" ).click( function( e ) {
    if ( !document.getElementById( 'primary-mobile-menu' ).classList.contains( '--active' ) ) return;
    e.preventDefault();
    this.parentElement.classList.toggle( '--active' );
    jQuery( this.parentElement ).find( '.sub-menu' ).slideToggle();
  } );

  jQuery( ".mobile-menu__close, .mobile-menu .menu-item:not(.menu-item-has-children) a" ).on( 'click', function( e ) {
    jQuery( '#primary-mobile-menu' ).removeClass( '--active' );
  } );

  jQuery( ".mobile-menu__toggle" ).on( 'click', function( e ) {
    jQuery( '#primary-mobile-menu' ).addClass( '--active' );
  } );

  //
  jQuery( '.wooProducts__slider' ).slick( {
    slidesToShow: 3,
    arrows: true,
    prevArrow,
    nextArrow,
    speed: 600,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  } );

  // About blog video modal
  jQuery( '[href="#about-video"]' ).click( function( e ) {
    e.preventDefault();
    jQuery( '.about-section__video' ).addClass( '--active' );
  } );
  jQuery( '.about-section__video, .about-section__close' ).on( 'click', function( e ) {
    jQuery( '.about-section__video' ).removeClass( '--active' );
  } );

  // Slick a slider only within a given media query
  function mediaSlick( mediaQuery, selector, slickSettings ) {
    const media = window.matchMedia( mediaQuery );
    let slicked = false;

    function handleListeners() {
      if ( media.matches && !slicked ) {
        jQuery( selector ).slick( slickSettings );
        slicked = true;
      } else if ( slicked ) {
        jQuery( selector ).slick( 'unslick' );
        slicked = false;
      }
    }
    handleListeners();
    media.addEventListener( 'change', handleListeners );
  }

  mediaSlick( '(max-width: 639px)', '.other-services__slider', {
    slidesToShow: 1,
    speed: 600,
    arrows: false,
    dots: true,
  } );
  mediaSlick( '(max-width: 1023px)', '.blueStrip__slider', {
    slidesToShow: 1,
    speed: 600,
    arrows: false,
    dots: true,
  } );

  //Show emergency widget only at certain points on the page
  const widget = document.querySelector( '.emergencyMobileLink .emergencyTab' );
  if ( widget ) {
    const footer = document.querySelector( '#contact' );
    const banner = document.querySelector( '.topIntro' ) || document.querySelector( '.alert' );
    const widgetObserver = new IntersectionObserver( ( entries, observer ) => {
      const isAboveFooter = window.scrollY + window.innerHeight < document.body.offsetHeight - footer.offsetHeight;
      const isBelowBanner = banner ? window.scrollY > banner.offsetHeight : true;
      if ( isAboveFooter && isBelowBanner ) widget.classList.add( '--active' );
      else widget.classList.remove( '--active' );
    }, { threshold: "0" } );
    document.querySelectorAll( 'body > *' ).forEach( section => {
      widgetObserver.observe( section );
    } );
    widgetObserver.observe( footer );
  }
} );